<template>
  <b-container class="contentcontainer site-detail__backups">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('site.extensions')}}</h2>
      </b-col>
      <b-col>
        <div class="actions">
          <button v-show="showUpdateItems" class="btn btn--primary" v-on:click="localUpdateAllExtensionForSite">
            {{$t('site.updateall')}}
          </button>
        </div>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <div class="info">
          <div v-if="showItems" class="table-responsive-lg">
            <table class="table table--overview">
              <thead>
              <tr>
                <th>
                  {{$t('site.extension')}}
                </th>
                <th>
                  {{$t('site.extensiontype')}}
                </th>
                <th>
                  {{$t('site.currentversion')}}
                </th>
                <th class="text-center">
                  {{$t('site.newversion')}}
                </th>
                <th class="text-center">
                  {{$t('site.update')}}
                </th>
                <th v-if="showAutoupdate" class="text-center">
                  {{$t('site.autoupdate')}}
                </th>
              </tr>
              </thead>

              <tbody>
              <site-detail-extension-item
                v-for="item in items"
                :key="item.id"
                v-bind="item"
                v-bind:show-autoupdate="showAutoupdate"
              >
              </site-detail-extension-item>
              </tbody>
            </table>
          </div>
          <div v-else class="no-updates">
            <div class="text">
              <div class="contentcontainer contentcontainer--success">
                <b-container>
                  <b-row align-v="center">
                    <b-col lg="2" sm="3" xl="1">
                      <img src="/images/icon/sitedetail/dashboard/general-success.svg"/>
                    </b-col>
                    <b-col lg="10" sm="9" xl="11">
                      <p v-html="$t('site.youaredoinggreat')"></p>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

import SiteDetailExtensionItem from './SiteDetailExtensionItem'

export default {

  name: 'ExtensionsSection',

  components: {

    SiteDetailExtensionItem
  },

  props: {

    showFullListLink: {
      default: true
    },
    showBackLink: {
      default: false
    },
    showUpdates: {
      default: true
    },
    showAutoupdate: {
      default: true
    }
  },

  computed: {

    ...mapState('site', [
      'siteDetail'
    ]),

    showItems () {
      if (this.showUpdates) {
        return this.showUpdateItems
      }

      return this.showExtensionItems
    },

    showUpdateItems () {
      return typeof this.siteDetail.data.updates !== 'undefined' && this.siteDetail.data.updates.length > 0
    },

    showExtensionItems () {
      return typeof this.siteDetail.data.extensions !== 'undefined' && this.siteDetail.data.extensions.length > 0
    },

    showAutoupdateCol () {
      return this.showAutoupdate
    }

  },

  data () {
    return {
      items: []
    }
  },

  watch: {

    'siteDetail': {
      handler: function () {
        this.preparePage()
      },
      deep: true
    }
  },

  methods: {

    ...mapMutations('site', [
      'showSiteDetailPageExtensions'
    ]),

    ...mapActions('site', [
      'updateAllExtensionsForSite'
    ]),

    close () {
      this.$emit('close-detail')
    },

    localUpdateAllExtensionForSite () {
      this.updateAllExtensionsForSite(this.siteDetail.id)
    },

    showSiteDetailPageExtensionsLocal () {
      this.showSiteDetailPageExtensions()
    },

    preparePage () {
      this.items = []

      if (this.showUpdates) {
        if (typeof this.siteDetail.data.updates !== 'undefined' && this.siteDetail.data.updates.length > 0) {
          this.items = this.siteDetail.data.updates
        }
      } else {
        if (typeof this.siteDetail.data.extensions !== 'undefined' && this.siteDetail.data.extensions.length > 0) {
          this.items = this.siteDetail.data.extensions
        }
      }
    }
  }
}
</script>
